export const RESET = 'EXCMDAILYPLAN_LIST_RESET'
export const SET_ITEMS = 'EXCMDAILYPLAN_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMDAILYPLAN_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMDAILYPLAN_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMDAILYPLAN_LIST_TOGGLE_LOADING'
